export default __webpack_public_path__ + "static/media/graham-ruttan-1t_9g-7NiTQ-unsplash.e5b382ba.jpg";